/*
 * Planigo
 * Auteur  : Stéphane Raverdy
 * Société : SCIAD 2026
 */
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/auth/forgot-password`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (res.ok) {
        setSent(true);
        toast.success('Email envoye');
      } else {
        toast.error(data.detail || 'Erreur');
      }
    } catch { toast.error('Erreur reseau'); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4" data-testid="forgot-password-page">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-xl">Mot de passe oublie</CardTitle>
        </CardHeader>
        <CardContent>
          {sent ? (
            <div className="text-center space-y-4" data-testid="forgot-success">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
                <span className="text-green-600 text-2xl">&#10003;</span>
              </div>
              <p className="text-sm text-slate-600">Si un compte existe avec l'email <strong>{email}</strong>, un lien de reinitialisation a ete envoye.</p>
              <p className="text-xs text-slate-500">Verifiez votre boite de reception et vos spams.</p>
              <Link to="/login" className="text-sm text-blue-600 hover:underline block mt-4">Retour a la connexion</Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <p className="text-sm text-slate-600">Entrez votre email pour recevoir un lien de reinitialisation.</p>
              <div className="space-y-1">
                <Label className="text-xs">Email</Label>
                <Input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="votre@email.com" required data-testid="forgot-email-input" />
              </div>
              <Button type="submit" className="w-full" disabled={loading || !email} data-testid="forgot-submit-btn">
                {loading ? 'Envoi...' : 'Envoyer le lien'}
              </Button>
              <Link to="/login" className="text-sm text-slate-500 hover:underline block text-center">Retour a la connexion</Link>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
